import {Injectable, Injector} from '@angular/core';

import {Observable, of} from 'rxjs';
import {HttpService, autoSubscribe} from 'projects/core/src/public-api';
import {tap, debounceTime} from 'rxjs/operators';
import {KanbanBoardStore, KanbanBoardFilters} from './kanban-board.store';
import {KanbanColumn} from './kanban-column';
import {TrelloCard} from 'projects/app-misc/src/app/modules/trello-misc/data/trello-card';
import {Project} from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import {ActionEventEmitter} from 'projects/core/src/lib/core/data/action-event-emitter';
import {CdkDragMove} from '@angular/cdk/drag-drop';
import {Memoize} from 'projects/core/src/lib/core/utils/decorators/memoize-decorator';

export interface ColumnChangeEvent {
  columnId: number
}

export interface InsertIntoColumnEvent extends ColumnChangeEvent {
  project: Project
  index: number
}

export interface RemoveFromColumnEvent extends ColumnChangeEvent {
  projectId: number
}

export interface MoveInColumnEvent extends ColumnChangeEvent {
  projectId: number
  indexFrom: number
  indexTo: number
}

@Injectable({
  providedIn: 'root',
})
export class KanbanBoardService {
  projectInsert = new ActionEventEmitter<InsertIntoColumnEvent>()

  projectRemove = new ActionEventEmitter<RemoveFromColumnEvent>()

  projectMoveIn = new ActionEventEmitter<MoveInColumnEvent>()

  projectDragMove = new ActionEventEmitter<CdkDragMove<string>>()

  constructor(
    protected kanbanBoardStore: KanbanBoardStore,
    protected http: HttpService
  ) {
  }


  loadColumns(): Observable<KanbanColumn[]> {
    return this.http.doHttpGet<KanbanColumn[]>(`/column/all`)
    .pipe(
      tap(columns => {
        this.kanbanBoardStore.upsertMany(columns)
      }),
      autoSubscribe()
    )
  }

  loadCustomColumns(filter?: KanbanBoardFilters): Observable<KanbanColumn[]> {
    const params = [];

    for(const prop in filter) {
      if(Object.prototype.hasOwnProperty.call(filter, prop)) {
        const value = filter[prop] as number[]
        if(typeof value !== 'undefined') {
          params.push(`${prop}=${value.join(',')}`)
        }
      }
    }

    return this.http.doHttpGet<KanbanColumn[]>(`/column/all/filtered?${params.join('&')}`)
    .pipe(
      tap(newColumns => {
        this.kanbanBoardStore.set(newColumns)
      })
    )
  }


  getProjectsFromColumn(colId: number, start: number, limit: number, filter?: KanbanBoardFilters): Observable<Project[]> {
    const params = [];

    for(const prop in filter) {
      if(Object.prototype.hasOwnProperty.call(filter, prop)) {
        const value = filter[prop] as number[]
        if(typeof value !== 'undefined') {
          params.push(`${prop}=${value.join(',')}`)
        }
      }
    }
    return this.http.doHttpGet<Project[]>(`/column/${colId}/cards-page/filtered?start=${start}&limit=${limit}&${params.join('&')}`)
    .pipe(
      tap(projs => {
        // this.kanbanBoardStore.set(newColumns)
      })
    )
  }

  getColumnNames(filter?: KanbanBoardFilters): Observable<KanbanColumn[]> {
    return this.http.doHttpGet<KanbanColumn[]>(`/column/all/names`)
  }

  moveCard(cardId: number, columnid: number, pos: number): Observable<TrelloCard> {
    return this.http.doHttpPut<TrelloCard>(`/column/move-card`, {
      card: cardId,
      column: columnid,
      position: pos
    })
  }
}
